import { formatDistanceToNow, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useDateLocale } from '@/lib/date-locale';

interface RelativeTimeProps {
  date: string | null;
  fallback?: string;
}

export function RelativeTime({ date, fallback }: RelativeTimeProps) {
  const { t } = useTranslation();
  const dateLocale = useDateLocale();

  if (!date) {
    return <span>{fallback ?? t('common.never')}</span>;
  }

  const parsed = parseISO(date);
  const relative = formatDistanceToNow(parsed, { addSuffix: true, locale: dateLocale });
  const absolute = parsed.toISOString();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-default">{relative}</span>
        </TooltipTrigger>
        <TooltipContent>
          <span className="font-mono text-xs">{absolute}</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
